import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** Bloco de conteúdo dentro do palco. Título opcional + ação à direita. */
export function Panel({
  title,
  action,
  children,
  className,
  bodyClassName,
}: {
  title?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
}) {
  return (
    <section
      className={cn('rounded-panel bg-raised/60 shadow-[inset_0_0_0_1px_var(--color-line)]', className)}
    >
      {(title || action) && (
        <header className="flex min-h-12 items-center justify-between gap-3 px-4 pt-3">
          {title && <h2 className="text-[14px] font-medium">{title}</h2>}
          {action}
        </header>
      )}
      <div className={cn('p-4', bodyClassName)}>{children}</div>
    </section>
  );
}
